// @flow
import React from 'react';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { Section } from '@finect/tabular-components/Section';
import { getSRRIByName } from '@finect/front-resources/RiskProfile';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { BarRiskProfile, RiskProfileJumbo } from './components';
import { PillSummary, Inner, Block, BlockInner } from './partials';

export const ViewRiskProfile = ({ user }: { user: Object }) => {
  const riskProfile = getSRRIByName(user.risk.valoration);

  if (!riskProfile) {
    return (
      <Section>
        <RiskProfileJumbo />
      </Section>
    );
  }

  const idSession = user.risk.session;
  const idApp = 'conoce-tu-perfil-inversor';

  const riskProfileMock = {
    conservative: 2,
    moderate: 4,
    aggresive: 6
  };

  const riskProfileValue = user.risk.value ? user.risk.value : riskProfileMock[riskProfile.name];

  return (
    <Section title="Tu perfil inversor" id="investorProfile">
      <Inner>
        <BlockInner>
          <Block>
            {'Tu perfil de riesgo calculado es:'} <span>{riskProfile.label}</span>
            <BarRiskProfile riskProfile={riskProfileValue} />
            <ParagraphSmall>{riskProfile.longDescription}</ParagraphSmall>
            <span>Como lo hemos calculado:</span>
            <ParagraphSmall>
              {`Se ha calculado tu perfil de riesgo en función de los datos que has declarado: tu patrimonio, nivel de tolerancia a los cambios del mercado y conocimientos.`}
            </ParagraphSmall>
          </Block>

          <PillSummary
            src={`${getSuperPartnerBaseURL()}/pills/es_ES/finect/default/${idApp}/${idSession}/summary`}
            scrolling="no"
          />
        </BlockInner>

        <AppLink href={`${getSuperPartnerBaseURL()}/pills/es_ES/finect/default/${idApp}`}>Volver a calcular</AppLink>
      </Inner>
    </Section>
  );
};
